import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { AppContext } from '../stores/app.store';
import { ArtistSlider } from './artist-slider.component';
import { KenBurnsImage } from './ken-burns-image.component';
import { QRCode } from './qr-code.component';
import { ZoomImage } from './zoom-image.component';

export const ArtContainer = (() => {
    const appStore = useContext(AppContext);
    const [viewIndex, setView] = useState(0);

    const views = [
        <KenBurnsImage image={appStore.auctionStore.auctionData?.images.large} />,
        <ZoomImage image={appStore.auctionStore.auctionData?.images.large} />
    ];

    function nextView() {
        const next = (viewIndex + 1) % views.length;
        setView(next);
    }

    function previousView() {
        const previous = (viewIndex - 1) < 0 ? (views.length - 1) - viewIndex : (viewIndex - 1);
        setView(previous);
    }

    return (
        <div className="h-100 position-relative bg-darker">
            <div className="z-mid position-absolute w-100 top-0">
                <ArtistSlider />
            </div>
            <div className="z-mid position-absolute w-100 bottom-0">
                <div className="d-flex justify-content-center align-items-center opacity-50 my-4">
                    <button className="btn btn-light rounded-circle me-2" onClick={() => previousView()}>
                        <FontAwesomeIcon icon="chevron-left" />
                    </button>
                    <button className="btn btn-light rounded-circle ms-2" onClick={() => nextView()}>
                        <FontAwesomeIcon icon="chevron-right" />
                    </button>
                </div>
            </div>
            <div style={{ width: '13vh', height: '13vh' }} className="position-absolute bottom-0 end-0 z-mid m-3">
                <QRCode url={appStore.auctionStore.nftUrl} />
            </div>
            {views.map((x, i) => i === viewIndex ? <div className="h-100" key={i}>{x}</div> : null)}
        </div>
    );
});